import {Component, ViewEncapsulation} from '@angular/core';
import {environment} from '../../environments/environment';

// @ts-ignore
const data = require('../../../package.json');

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent {

  constructor() {}

  /***** START - PRIVATE MEMBERS *****/
  /***** END - PRIVATE MEMBERS *****/

  /***** START - PUBLIC MEMBERS *****/
  readonly config = environment;
  showBuildNumbers: boolean = this.config.showBuildNumbers;
  buildNumber: string = data.version;

  currentYear: number = new Date().getFullYear();
  /***** END - PUBLIC MEMBERS *****/

}
